import { useConfiguration } from '@/parts/configuration/wrapper'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { useRouter } from '@/parts/router/query-preserving'
import { useStudent } from '@/parts/student/hook'
import { useEffect, useRef } from 'react'
import { initialisePostHog, trackPageview } from './tracker'

export default function TrackWithPostHog() {
  const { posthog: config } = useConfiguration()
  const isSetupEnabled = useBooleanFlagValue('posthog-capture', false)
  const isPageviewCaptureEnabled = useBooleanFlagValue(
    'msp_posthog-capture-pageviews',
    false,
  )
  const { asPath } = useRouter()
  const { id: studentId, customerType } = useStudent()
  const isInitialised = useRef(false)

  useEffect(() => {
    if (!isSetupEnabled) return

    if (!isInitialised.current) {
      initialisePostHog(config, studentId, customerType)
      isInitialised.current = true
    }

    if (isPageviewCaptureEnabled) {
      trackPageview()
    }
  }, [
    asPath,
    config,
    customerType,
    isPageviewCaptureEnabled,
    isSetupEnabled,
    studentId,
  ])

  return null
}
